import * as yup from 'yup'
import type { CardElementChangeEvent } from '@pff-consumer/schema/account/subscriptions'

export const baseSchema = {
  first_name: yup.string().required('Please enter first name'),
  last_name: yup.string().required('Please enter last name'),
  address1: yup.string().required('Please enter billing address'),
  city: yup.string().required('Please enter city'),
  state: yup.string().required('Please enter state'),
  country: yup.string(),
  postal_code: yup.string().required('Please enter zip code'),
}

export const subscribeFormSchema = yup
  .object({
    ...baseSchema,
    cardDetails: yup
      .mixed<CardElementChangeEvent>()
      .test('validCardDetails', 'Please enter valid card details', (value) => {
        if (!value) return false
        return value.valid
      })
      .required(),
  })
  .required()
